import { useRef } from 'react'
import { IconButton, Inline, Popover } from '@leroy-merlin-br/backyard-react-ui'

import socialMediaList from './utils/social-media-list'
import { Icon } from '../Icon'
import * as S from './styled'

const ShareButton = () => {
  const buttonRef = useRef()

  const pageUrl = window.location.href

  const renderButtons = () => {
    return (
      <Inline spacing="bit" noWrap>
        {socialMediaList.map(({ name, url }) => (
          <a key={name} href={`${url}${pageUrl}`} title={name} target="_blank">
            <Icon name={name} />
          </a>
        ))}
      </Inline>
    )
  }

  return (
    <S.ShareButton>
      <Popover
        title="Compartilhar"
        content={renderButtons()}
        placement="left-start"
        trigger="click"
        interactive
        onUntrigger={() => buttonRef.current.blur()}
      >
        <IconButton ref={buttonRef} variant="ghost" size="kilo" label="compartilhar">
          <Icon name="share" />
        </IconButton>
      </Popover>
    </S.ShareButton>
  )
}

export default ShareButton
